module.exports = __webpack_public_path__ + "img/logo.0e52ff47.svg";